/* ====================================================================
   HELPERS —> MANAGE BEHAVIOURS
   ==================================================================== */

export const manageBehaviours = (
  loadedBehavioursModule,
  dataAttr = "behaviour"
) => {
  const loadedBehaviourNames = Object.keys(loadedBehavioursModule);
  const loadedBehaviours = {};
  const activeBehaviours = new Map();

  const loopBehaviours = (node, cb) => {
    if (!("querySelectorAll" in node)) {
      /**
       * Ignore all text or comment nodes
       */

      return;
    }

    const behaviourNodes = [node].concat(
      [].slice.call(node.querySelectorAll(`[data-${dataAttr}]`))
    );

    for (let i = 0; i < behaviourNodes.length; i++) {
      const behaviourNode = behaviourNodes[i];
      const behaviourNames =
        behaviourNode.dataset &&
        behaviourNode.dataset[dataAttr] &&
        behaviourNode.dataset[dataAttr].split(" ");

      if (behaviourNames) {
        behaviourNames.forEach(name => {
          cb(name, behaviourNode);
        });
      }
    }
  };

  const destroyBehaviours = node => {
    loopBehaviours(node, (bName, bNode) => {
      const nodeBehaviours = activeBehaviours.get(bNode);

      if (!nodeBehaviours || !nodeBehaviours[bName]) {
        console.warn(`No behaviour ${bName} instance on:`, bNode);
        return;
      }

      nodeBehaviours[bName].destroy();
      delete nodeBehaviours[bName];
    });
  };

  const createBehaviours = node => {
    loopBehaviours(node, (bName, bNode) => {
      if (!loadedBehaviours[bName]) {
        console.warn(`No loaded behaviour called ${bName}`);
        return;
      }

      const instance = new loadedBehaviours[bName](bNode);
      instance.init();

      const nodeBehaviours = activeBehaviours.get(bNode) || {};
      nodeBehaviours[bName] = instance;
      activeBehaviours.set(bNode, nodeBehaviours);
    });
  };

  const observeBehaviours = () => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.removedNodes) {
          for (let i = 0; i < mutation.removedNodes.length; i++) {
            const node = mutation.removedNodes[i];
            destroyBehaviours(node);
          }
        }
      });

      mutations.forEach(mutation => {
        if (mutation.addedNodes) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            createBehaviours(node);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
  };

  loadedBehaviourNames.forEach(name => {
    loadedBehaviours[name] = loadedBehavioursModule[name];
  });

  createBehaviours(document);
  observeBehaviours();
};

export default manageBehaviours;
